var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pdfContainer",staticClass:"form-control p-0",attrs:{"id":"ContractPDF"}},[(_vm.pdfSource)?_c('vue-pdf-embed',{attrs:{"source":_vm.pdfSource,"width":_vm.pdfWidth},on:{"loaded":_vm.tryViewContract}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }